import React, { createContext, Dispatch, useState } from 'react';
import {
  IConfirmationDrawerData,
  IEditPickupLocationOrderIds,
  IGetStoreLocationsResponse,
} from '../models/edit-pickup-location';

// ******* TYPES ******
export interface IEditPickupLocationContext {
  isStoreSelection: boolean;
  setIsStoreSelection: Dispatch<React.SetStateAction<boolean>>;
  isConfirmation: boolean;
  setIsConfirmation: Dispatch<React.SetStateAction<boolean>>;
  skeletonLoading: boolean;
  setSkeletonLoading: Dispatch<React.SetStateAction<boolean>>;
  storeLocationData: IGetStoreLocationsResponse | undefined;
  setStoreLocationData: Dispatch<
    React.SetStateAction<IGetStoreLocationsResponse | undefined>
  >;
  isLocationChangeConfirmed: boolean;
  setIsLocationChangeConfirmed: Dispatch<React.SetStateAction<boolean>>;
  selectedStoreData: IConfirmationDrawerData | undefined;
  setSelectedStoreData: Dispatch<
    React.SetStateAction<IConfirmationDrawerData | undefined>
  >;
  editPickupLocationOrderIds: IEditPickupLocationOrderIds | undefined;
  setEditPickupLocationOrderIds: Dispatch<
    React.SetStateAction<IEditPickupLocationOrderIds | undefined>
  >;
}

type IEditPickupLocationProvider = {
  children: React.ReactNode;
};

// ******* CONTEXT ******
export const EditPickupLocationContext =
  createContext<IEditPickupLocationContext>({} as IEditPickupLocationContext);

// ******* PROVIDER ******
export function EditPickupLocationProvider({
  children,
}: IEditPickupLocationProvider) {
  const [isStoreSelection, setIsStoreSelection] = useState<boolean>(true);
  const [isConfirmation, setIsConfirmation] = useState<boolean>(false);
  const [skeletonLoading, setSkeletonLoading] = useState(false);
  const [storeLocationData, setStoreLocationData] =
    useState<IGetStoreLocationsResponse>();
  const [isLocationChangeConfirmed, setIsLocationChangeConfirmed] =
    useState<boolean>(false);
  const [selectedStoreData, setSelectedStoreData] =
    useState<IConfirmationDrawerData>();
  const [editPickupLocationOrderIds, setEditPickupLocationOrderIds] =
    useState<IEditPickupLocationOrderIds>();
  return (
    <EditPickupLocationContext.Provider
      value={{
        isStoreSelection,
        setIsStoreSelection,
        isConfirmation,
        setIsConfirmation,
        skeletonLoading,
        setSkeletonLoading,
        storeLocationData,
        setStoreLocationData,
        isLocationChangeConfirmed,
        setIsLocationChangeConfirmed,
        selectedStoreData,
        setSelectedStoreData,
        editPickupLocationOrderIds,
        setEditPickupLocationOrderIds,
      }}
    >
      {children}
    </EditPickupLocationContext.Provider>
  );
}
